var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.5 16.4c3.4887 1.48 5.43 1.4532 8.8 0m5.5-6.43464v8.59814c0 2.4502-1.9699 4.4365-4.4 4.4365h-11c-2.43005 0-4.4-1.9863-4.4-4.4365v-8.59814c0-1.33205.59361-2.59361 1.61685-3.43618l5.49999-4.5289c1.61966-1.333706 3.94666-1.333708 5.56636 0l5.4999 4.5289c1.0233.84257 1.6169 2.10413 1.6169 3.43618z",
    stroke: "#b0b0b0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.520a27c891e4946451f5e577bd1bbcfe.svg";
export { ForwardRef as ReactComponent };